import ECharts from "vue-echarts";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll";
import "echarts/lib/component/title";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";
import { WalletService } from "@/services";
import makeSecure from "@/components/MakeSecure";

export default {
  name: "wallet-hero",
  components: {
    "v-chart": ECharts,
    makeSecure
  },
  props: [],
  mixins: [$exponent, $thousandMask],
  data() {
    return {
      hideAssets: localStorage.getItem("secure") === "true",
      option: {
        legend: {
          type: "scroll",
          top: this.$vuetify.breakpoint.smAndDown ? "0" : "center",
          left: this.$vuetify.breakpoint.smAndDown
            ? "center"
            : this.$vuetify.rtl
            ? "left"
            : "right",
          orient: this.$vuetify.breakpoint.smAndDown
            ? "horizontal"
            : "vertical",
          align: this.$vuetify.rtl ? "right" : "left",
          itemWidth: 15,
          itemHeight: 15,
          data: [],
          verticalAlign: "middle",
          textStyle: {
            color: this.$vuetify.theme.dark
              ? this.$vuetify.theme.themes.dark.gray1
              : this.$vuetify.theme.themes.light.gray1,
            fontFamily: "webIRANSansRegular",
            fontSize: 12
          }
        },
        series: [
          {
            name: "property",
            type: "pie",
            radius: ["81%", "90%"],
            hoverOffset: 0,
            top: this.$vuetify.breakpoint.smAndDown ? "40%" : "0",
            right: this.$vuetify.breakpoint.smAndDown
              ? "0%"
              : this.$vuetify.rtl
              ? "0%"
              : "70",
            width: "auto",
            height: "auto",
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "center",
              formatter: ["{x|}"].join("\n"),
              rich: {
                x: {
                  backgroundColor: {
                    image: `${require("@/assets/image/donut_qty.svg")}`
                  },
                  height: 21,
                  width: 21
                }
              }
            },
            labelLine: {
              show: true
            },
            emphasis: {
              focus: "self"
            },
            data: []
          }
        ]
      },
      noData: false,
      walletHeroLoader: true,
      marketConditions: "",
      totalWallet: {},
      isLoadedTotalWallet: false
    };
  },
  computed: {
    ...mapGetters({
      newWallets: types.wallets.getters.GET_NEW_WALLETS,
      userSetting: types.userSetting.getters.GET_USER_SETTING,
      exchangeWallets: types.wallets.getters.GET_EXCHANGE_WALLETS,
      getMarketConditions: types.wallets.getters.GET_MARKET_CONDITIONS_WALLETS,
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),
    walletData() {
      if (Object.entries(this.newWallets).length > 0) {
        return this.newWallets;
      }
    }
    // getChartData() {
    //   this.resetData();
    //   let data = [];
    //   let chartData = [];
    //   let sumOfSharePercent = 0;
    //   let i = 0;
    //   if (this.walletData) {
    //     this.walletData.find(elem => {
    //       if (elem.balance > 0) {
    //         data.push(elem);
    //       }
    //     });
    //     data = data.sort(
    //       (a, b) =>
    //         parseFloat(b.share_percent.exact) -
    //         parseFloat(a.share_percent.exact)
    //     );
    //     if (data.length !== 0) {
    //       this.noData = false;
    //       for (i; i < data.length && i < 4; i++) {
    //         chartData.push({
    //           value: data[i].share_percent.exact,
    //           name: data[i].currency.iso,
    //           icon: `image://${data[i].currency.logo}`,
    //           emphasis: {
    //             label: {
    //               show: true,
    //               formatter: ["{x|}", "{a|{d}}", "{b|{b}}"].join("\n"),
    //               rich: {
    //                 a: {
    //                   color: this.$vuetify.theme.dark
    //                     ? this.$vuetify.theme.themes.dark.gray1
    //                     : this.$vuetify.theme.themes.light.gray1,
    //                   fontFamily: "webIRANSansRegular",
    //                   fontSize: "14",
    //                   lineHeight: 30,
    //                   align: "center",
    //                   verticalAlign: "middle"
    //                 },
    //                 b: {
    //                   color: this.$vuetify.theme.dark
    //                     ? this.$vuetify.theme.themes.dark.gray2
    //                     : this.$vuetify.theme.themes.light.gray2,
    //                   fontFamily: "webIRANSansRegular",
    //                   fontSize: "12",
    //                   lineHeight: 5,
    //                   align: "center",
    //                   verticalAlign: "middle"
    //                 },
    //                 x: {
    //                   backgroundColor: {
    //                     image: `${data[i].currency.logo}`
    //                   },
    //                   height: 20,
    //                   width: 20
    //                 }
    //               }
    //             }
    //           },
    //           itemStyle: {
    //             borderRadius: "10%",
    //             color: `${data[i].currency.color}`,
    //             borderColor: this.$vuetify.theme.dark
    //               ? this.$vuetify.theme.themes.dark.gray10
    //               : this.$vuetify.theme.themes.light.gray10,
    //             borderWidth: "4"
    //           }
    //         });
    //         sumOfSharePercent += data[i].share_percent.exact;
    //       }
    //       if (i === 4) {
    //         chartData.push({
    //           value: 100 - sumOfSharePercent,
    //           name: this.$t("walletPage.walletHero.otherCurrencies"),
    //           icon: `image://${require("@/assets/image/other_coins.svg")}`,
    //           emphasis: {
    //             label: {
    //               show: true,
    //               formatter: ["{x|}", "{a|{d}}", "{b|{b}}"].join("\n"),
    //               rich: {
    //                 a: {
    //                   color: this.$vuetify.theme.dark
    //                     ? this.$vuetify.theme.themes.dark.gray1
    //                     : this.$vuetify.theme.themes.light.gray1,
    //                   fontFamily: "webIRANSansRegular",
    //                   fontSize: "14",
    //                   lineHeight: 30,
    //                   align: "center",
    //                   verticalAlign: "middle"
    //                 },
    //                 b: {
    //                   color: this.$vuetify.theme.dark
    //                     ? this.$vuetify.theme.themes.dark.gray2
    //                     : this.$vuetify.theme.themes.light.gray2,
    //                   fontFamily: "webIRANSansRegular",
    //                   fontSize: "12",
    //                   lineHeight: 5,
    //                   align: "center",
    //                   verticalAlign: "middle"
    //                 },
    //                 x: {
    //                   backgroundColor: {
    //                     image: `${require("@/assets/image/otherCoins.svg")}`
    //                   },
    //                   height: 20,
    //                   width: 20
    //                 }
    //               }
    //             }
    //           },
    //           itemStyle: {
    //             borderRadius: "10%",
    //             color: this.$vuetify.theme.dark
    //               ? this.$vuetify.theme.themes.dark.error
    //               : this.$vuetify.theme.themes.light.error,
    //             borderColor: this.$vuetify.theme.dark
    //               ? this.$vuetify.theme.themes.dark.background
    //               : this.$vuetify.theme.themes.light.background,
    //             borderWidth: "4"
    //           }
    //         });
    //       }
    //     } else {
    //       this.noData = true;
    //       chartData.push({
    //         value: 100,
    //         name: "",
    //         icon: "",
    //         emphasis: {
    //           label: {
    //             show: false
    //           }
    //         },
    //         itemStyle: {
    //           borderRadius: "10%",
    //           color: this.$vuetify.theme.dark
    //             ? this.$vuetify.theme.themes.dark.gray2
    //             : this.$vuetify.theme.themes.light.gray2,
    //           borderColor: this.$vuetify.theme.dark
    //             ? this.$vuetify.theme.themes.dark.background
    //             : this.$vuetify.theme.themes.light.background,
    //           borderWidth: "4"
    //         }
    //       });
    //     }
    //
    //     return chartData;
    //   }
    // },
    // setChartData() {
    //   if (this.getChartData && !this.noData) {
    //     this.getChartData.forEach(elem => {
    //       this.option.series[0].data.push(elem);
    //       this.option.legend.data.push({
    //         name: elem.name,
    //         icon: elem.icon
    //       });
    //     });
    //   } else if (this.getChartData && this.noData) {
    //     this.getChartData.forEach(elem => {
    //       this.option.series[0].data.push(elem);
    //       this.option.legend.data.push({
    //         show: false
    //       });
    //     });
    //   }
    // },
    // setExchangeWalletData() {
    //   let isDeposit = false;
    //   let isWithdraw = false;
    //   let isExchange = false;
    //   if (Object.entries(this.exchangeWallets).length > 0) {
    //     let exchangeItem = this.exchangeWallets.data["IRR"];
    //     exchangeItem.find(element => {
    //       if (element.to === "IRR") {
    //         if (element.normal_balance) {
    //           isDeposit = true;
    //         }
    //         if (element.balance_normal) {
    //           isWithdraw = true;
    //         }
    //       }
    //       if (element.balance_balance) {
    //         isExchange = true;
    //       }
    //     });
    //     return {
    //       isExchange: isExchange,
    //       isWithdraw: isWithdraw,
    //       isDeposit: isDeposit
    //     };
    //   }
    // },
    // checkTransferActive() {
    //   let data = false;
    //   if (Object.entries(this.newWallets).length > 0) {
    //     this.newWallets.forEach(elem => {
    //       if (elem.is_transfer_to_market_place_active) {
    //         data = true;
    //       }
    //     });
    //     return data;
    //   }
    // }
  },
  mounted() {
    this.setSecureValue(localStorage.getItem("secure") === "true");
    this.getTotalWallet();
  },
  watch: {
    getMarketConditions: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.marketConditions = newValue;
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setOpenModalMarketConditions:
        types.wallets.actions.SET_OPEN_MODAL_MARKET_CONDITIONS_WALLETS,
      setMarketConditions: types.wallets.actions.SET_MARKET_CONDITIONS_WALLETS,
      setSecureValue: types.secure.actions.SET_SECURE
    }),
    hideAllAssets() {
      this.hideAssets = !this.hideAssets;
      this.setSecureValue(this.hideAssets).then(() => {
        localStorage.setItem("secure", this.hideAssets);
      });
    },
    resetData() {
      this.option = {
        legend: {
          type: "scroll",
          top: this.$vuetify.breakpoint.smAndDown ? "0" : "center",
          left: this.$vuetify.breakpoint.smAndDown
            ? "center"
            : this.$vuetify.rtl
            ? "left"
            : "right",
          orient: this.$vuetify.breakpoint.smAndDown
            ? "horizontal"
            : "vertical",
          align: this.$vuetify.rtl ? "right" : "left",
          itemWidth: 15,
          itemHeight: 15,
          data: [],
          verticalAlign: "middle",
          textStyle: {
            color: this.$vuetify.theme.dark
              ? this.$vuetify.theme.themes.dark.gray1
              : this.$vuetify.theme.themes.light.gray1,
            fontFamily: "webIRANSansRegular",
            fontSize: 12
          }
        },
        series: [
          {
            name: "property",
            type: "pie",
            radius: ["81%", "100%"],
            hoverOffset: 0,
            top: this.$vuetify.breakpoint.smAndDown ? "40%" : "0",
            right: this.$vuetify.breakpoint.smAndDown
              ? "0%"
              : this.$vuetify.rtl
              ? "0%"
              : "70",
            width: "auto",
            height: "auto",
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "center",
              formatter: ["{x|}"].join("\n"),
              rich: {
                x: {
                  backgroundColor: {
                    image: `${require("@/assets/image/donut_qty.svg")}`
                  },
                  height: 21,
                  width: 21
                }
              }
            },
            labelLine: {
              show: true
            },
            emphasis: {
              focus: "self"
            },
            data: []
          }
        ]
      };
    },
    // changeTransferRoute() {
    //   if (this.marketConditions) {
    //     this.$router.push({ path: `operations/transfer?from=BTC` });
    //   } else {
    //     TransferService.getUserAgreement()
    //       .then(response => {
    //         if (response.data.data.agreement_status) {
    //           // this.setMarketConditions(true);
    //           this.$router.push({ path: `operations/transfer?from=BTC` });
    //         } else {
    //           this.setOpenModalMarketConditions(true);
    //         }
    //       })
    //       .catch(error => {
    //         this.$toast.error(error.data.message);
    //       });
    //   }
    // },
    getTotalWallet() {
      WalletService.TotalWallet().then(response => {
        this.walletHeroLoader = false;
        this.totalWallet = response.data.data;
        this.isLoadedTotalWallet = true;
      });
    }
  }
};
